/* eslint-disable import/no-anonymous-default-export */
import { Space, Tag } from "antd";

interface CategoriasCodigoTagsProps {
    categoriasCodigo?: string | null
}

export default (props: CategoriasCodigoTagsProps) => {

    const categorias = (props.categoriasCodigo ?? "")
        .split(",")
        .map(categoria => categoria.trim())
        .filter(categoria => categoria !== "");

    if (categorias.length === 0) {
        return <div style={{ textAlign: 'center' }}>Sin categoría</div>;
    }

    return (
        <Space size={[4, 4]} wrap style={{ justifyContent: 'center', width: '100%' }}>
            {categorias.map(categoria => (
                <Tag key={categoria} color="blue" style={{ marginRight: 0 }}>{categoria}</Tag>
            ))}
        </Space>
    );
}
